import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const isNative = Capacitor.isNativePlatform();

// Safe storage wrapper that works on both web and native
export const storage = {
  async getItem(key) {
    try {
      if (isNative) {
        const { value } = await Preferences.get({ key });
        return value;
      } else {
        return localStorage.getItem(key);
      }
    } catch (e) {
      console.warn("Storage getItem failed:", e);
      return null;
    }
  },

  async setItem(key, value) {
    try {
      if (isNative) {
        await Preferences.set({ key, value });
        // Verify the write was successful on iOS
        if (key === "skybday_token") {
          const { value: storedValue } = await Preferences.get({ key });
          if (storedValue !== value) {
            console.error("[Storage] Token verification failed after write!");
          } else {
            console.log("[Storage] Token successfully written and verified");
          }
        }
      } else {
        localStorage.setItem(key, value);
      }
    } catch (e) {
      console.warn("Storage setItem failed:", e);
    }
  },

  async removeItem(key) {
    try {
      if (isNative) {
        await Preferences.remove({ key });
      } else {
        localStorage.removeItem(key);
      }
    } catch (e) {
      console.warn("Storage removeItem failed:", e);
    }
  },

  // Synchronous version for initial load (web only, returns null on native)
  getItemSync(key) {
    try {
      if (!isNative) {
        return localStorage.getItem(key);
      }
      return null;
    } catch (e) {
      return null;
    }
  }
};

export default storage;
